/**
 * Care Router
 * CCH Care - Version 1.0
 * 
 * Route definitions:
 * - Public: Landing page, Login, Get Started
 * - Protected: Dashboard, ADL Flow Sheet, Alerts, Admin
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import LandingPage from '../../features/home/LandingPage';
import LoginPage from '../../features/auth/LoginPage';
import RegisterPage from '../../features/auth/RegisterPage';
import ActivatePage from '../../features/auth/ActivatePage';
import AppShell from '../layout/AppShell';

// Phase 2+ placeholders — will be replaced with real components
function ShiftDashboard() {
  return <div style={{ padding: 40, textAlign: 'center', color: '#6B7B8D' }}>
    <div style={{ fontSize: 48, marginBottom: 16 }}>🏥</div>
    <h2>Shift Dashboard</h2>
    <p>Phase 2 — Coming soon</p>
  </div>;
}

function ADLFlowSheet() {
  return <div style={{ padding: 40, textAlign: 'center', color: '#6B7B8D' }}>
    <div style={{ fontSize: 48, marginBottom: 16 }}>📋</div>
    <h2>ADL Flow Sheet</h2>
    <p>Phase 3 — Coming soon</p>
  </div>;
}

function AlertsList() {
  return <div style={{ padding: 40, textAlign: 'center', color: '#6B7B8D' }}>
    <div style={{ fontSize: 48, marginBottom: 16 }}>🔔</div>
    <h2>Alerts</h2>
    <p>Phase 4 — Coming soon</p>
  </div>;
}

function AdminPage() {
  return <div style={{ padding: 40, textAlign: 'center', color: '#6B7B8D' }}>
    <div style={{ fontSize: 48, marginBottom: 16 }}>⚙️</div>
    <h2>Admin</h2>
    <p>Phase 4 — Coming soon</p>
  </div>;
}

export default function CareRouter() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/get-started" element={<RegisterPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/activate" element={<ActivatePage />} />

      {/* Protected routes wrapped in AppShell */}
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <AppShell />
        </ProtectedRoute>
      }>
        {/* Default: Shift Dashboard */}
        <Route index element={<ShiftDashboard />} />
        
        {/* ADL Flow Sheet */}
        <Route path="adl/:patientId" element={<ADLFlowSheet />} />
        
        {/* Alerts */}
        <Route path="alerts" element={<AlertsList />} />
        
        {/* Admin (permission-gated) */}
        <Route path="admin/*" element={
          <ProtectedRoute permission="facilities.manage">
            <AdminPage />
          </ProtectedRoute>
        } />
      </Route>

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
